export const model = {
  id: null,
  device_name: '',
  serial_number:'',
  provider: 'zkteco',
  has_static_ip: false,
  ip_address: '',
  port: '4370',
  attendance_type: 'entrance',
  type: 'kpp',
  company_ids: [],
  device_type_id:'',
  security_location_id:'',
  status_id: null,
  created_at: '',
  updated_at: ''  
};
